module.exports = __webpack_public_path__ + "img/error.64868842.svg";